const directExcelUrlPattern = /\.(xlsx|xlsm|xls)(?:$|[?#])/i

const getGoogleSpreadsheetExportUrl = (url: URL) => {
  const publishedMatch = url.pathname.match(
    /\/spreadsheets(?:\/u\/\d+)?\/d\/e\/([^/]+)/
  )
  if (publishedMatch?.[1]) {
    return `https://docs.google.com/spreadsheets/d/e/${publishedMatch[1]}/pub?output=xlsx`
  }

  const match = url.pathname.match(/\/spreadsheets(?:\/u\/\d+)?\/d\/([^/]+)/)
  if (!match?.[1]) return null

  return `https://docs.google.com/spreadsheets/d/${match[1]}/export?format=xlsx`
}

const getGoogleDriveDownloadUrl = (url: URL) => {
  const fileMatch = url.pathname.match(/\/file\/d\/([^/]+)/)
  const id = fileMatch?.[1] ?? url.searchParams.get('id')
  if (!id) return null

  return `https://drive.google.com/uc?export=download&id=${id}`
}

const OFFICE_VIEWER_HOST = 'view.officeapps.live.com'

const getOfficeViewerSourceUrl = (url: URL) => {
  const source = url.searchParams.get('src')?.trim()
  if (!source) return null

  try {
    const sourceUrl = new URL(source)
    return sourceUrl.protocol === 'http:' || sourceUrl.protocol === 'https:'
      ? sourceUrl.toString()
      : null
  } catch {
    return null
  }
}

export const resolveExcelDownloadUrl = async (rawUrl: string) => {
  const trimmedUrl = rawUrl.trim()
  const parsedUrl = new URL(trimmedUrl)
  const host = parsedUrl.hostname.toLowerCase()

  if (host === OFFICE_VIEWER_HOST) {
    return getOfficeViewerSourceUrl(parsedUrl) ?? trimmedUrl
  }

  if (host === 'docs.google.com') {
    return getGoogleSpreadsheetExportUrl(parsedUrl) ?? trimmedUrl
  }

  if (host === 'drive.google.com') {
    return getGoogleDriveDownloadUrl(parsedUrl) ?? trimmedUrl
  }

  if (
    host.includes('yandex') &&
    !directExcelUrlPattern.test(parsedUrl.pathname)
  ) {
    const apiUrl = `https://cloud-api.yandex.net/v1/disk/public/resources/download?public_key=${encodeURIComponent(trimmedUrl)}`
    const response = await fetch(apiUrl)
    if (!response.ok) {
      throw new Error('Яндекс.Диск не вернул ссылку на скачивание файла')
    }

    const data = (await response.json()) as { href?: string }
    if (!data.href) {
      throw new Error('В ответе Яндекс.Диска нет ссылки на скачивание файла')
    }

    return data.href
  }

  return trimmedUrl
}
